import {
    apiRequest,
    simulation, 
    presensiCancel
} from "../../../../../services/adapters/kepegawaian/presensiService"

class SimulationRepository {

    fetchSimulation = async (query) => {
        return await apiRequest("get", simulation, {
            params: query
        }, true)
    }

    fetchCancel = async (query) => {
        return await apiRequest("post", presensiCancel, {
            body: query
        }, true)
    }
}

export default SimulationRepository